import { render } from "./ForgotPasswordPopup.vue?vue&type=template&id=77bcee81&scoped=true&ts=true"
import script from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPopup.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPopup.vue?vue&type=style&index=0&id=77bcee81&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bcee81"]])

export default __exports__